import { inject, onMounted, onUnmounted, reactive, nextTick } from 'vue';
import { useStore } from "vuex";
import { useScrollState } from "@/composables/useScrollState";
import { trackPixel } from './Pixel';

export default function Watchlist() {

    const axios = inject('axios');
    const store = useStore();

    // Set offset for scroll loading based on window height
    let offset = 12;
    const windowHeight = window.innerHeight;
    if (windowHeight > 1450) {
        offset = 24;
    } else if (windowHeight > 1100) {
        offset = 18;
    }
    const normalOffset = offset;
    const STORAGE_KEY = 'watchlist';

    var page = 1;
    let lastPage = 0;
    let load = false;

    const watchlist = reactive({
        loading: false,
        data: [],
        error: '',
        loadingScroll: false
    })
    const getWatchlist = async() => {
        if (axios.isLoggedIn) {
            watchlist.loading = true;
            load = true;
            axios.authApi.get('/watchlist', {
                params: {
                    page: page,
                    offset: offset
                }
            }).then((resp) => {
                if (resp.status) {
                    watchlist.data = resp.data.data;
                    lastPage = resp.data.data.last_page;
                    load = false;
                } else {
                    watchlist.error = resp.data.error;
                }
            }).catch(function(error) {
                console.log(error);
            }).finally(() => (watchlist.loading = false));
        } else {}
    };

    const setWatchlist = async (product) => {
        if (!product.watchlist) {
            await axios.authApi.post('/add-watchlist', {
                product_id: product.id
            }).then((resp) => {
                if (resp.status) {
                    store.dispatch("setProduct", {});
                    trackPixel('AddToWishlist', {
                        content_ids: [product.id],
                        content_type: 'product',
                        content_name: product.name,
                    });
                }
            }).catch(function(error) {
                console.log(error);
            });
        } else {
            await axios.authApi.get('/remove-watchlist', {
                params: {
                    product_id: product.id

                }
            }).then((resp) => {
                if (resp.status) {
                    store.dispatch("setProduct", {});
                }
            }).catch(function(error) {
                console.log(error);
            });
        }
    };

    const scrollState = useScrollState();

    function saveScrollState() {
        scrollState.save(STORAGE_KEY, { page, scrollY: window.scrollY });
    }

    async function restoreScrollState() {
        const saved = scrollState.restore(STORAGE_KEY);
        if (!saved) return false;

        if (saved.page > 1 && axios.isLoggedIn) {
            watchlist.loading = true;
            load = true;
            await axios.authApi.get('/watchlist', {
                params: { page: 1, offset: saved.page * normalOffset }
            }).then((resp) => {
                if (resp.status) {
                    watchlist.data = resp.data.data;
                    lastPage = Math.ceil(resp.data.data.total / normalOffset);
                    page = saved.page;
                    load = false;
                }
            }).catch(() => {}).finally(() => (watchlist.loading = false));
        }

        await nextTick();
        requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY, behavior: 'smooth' }));
        return true;
    }

    const handleScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            if (page < lastPage && !load) {
                page++;
                watchlist.loadingScroll = true;
                load = true;
                axios.authApi.get('/watchlist', {
                    params: {
                        page: page,
                        offset: offset
                    }
                }).then((resp) => {
                    if (resp.status) {
                        for (let i in resp.data.data.data) {
                            watchlist.data.data.push(resp.data.data.data[i]);
                        }
                        lastPage = resp.data.data.last_page;
                        load = false;
                    } else {
                        watchlist.error = resp.data.error;
                    }
                }).catch(function(error) {
                    console.log(error);
                }).finally(() => (watchlist.loadingScroll = false));
            }
        }
    }

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('beforeunload', saveScrollState);
    });

    onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('beforeunload', saveScrollState);
    });

    return {
        watchlist,
        setWatchlist,
        getWatchlist,
        isLoggedIn: axios.isLoggedIn,
        saveScrollState,
        restoreScrollState,
    }

}